import { Modal } from 'components'
import { type HeadItemType, Table } from 'components/Table'
import type { AnalysisInconsistency } from 'services/analysis/interfaces'
import { setUploadErrors } from 'store/ExtraVolumeContext/ExtraVolumeSlice'
import { useDispatch } from 'store/store'

import * as S from './styles'

const headDataUpload: HeadItemType[] = [
  { columnName: 'Linha', label: 'Linha' },
  { columnName: 'Coluna', label: 'Nome da Coluna' },
  { columnName: 'Mensagem', label: 'Descrição de erro' },
]

interface UploadAnalysisErrorModalProps {
  data: AnalysisInconsistency[]
}

const UploadAnalysisErrorModal: React.FC<UploadAnalysisErrorModalProps> = ({ data }) => {
  const dispatch = useDispatch()

  const handleSetOpen = (isOpen: boolean) => {
    if (!isOpen) {
      dispatch(setUploadErrors([]))
    }
  }

  const renderSummary = () => {
    const amount = data?.length ?? 0
    return amount > 1 ? `${amount} erros encontrados` : `${amount} erro encontrado`
  }

  const renderBody = () => {
    return data.map((item) => {
      const key = `${item.Linha}-${item.Coluna}`

      return {
        content: [
          <S.DataWrap key={`lineNumber-${key}`}>
            <span>{item.Linha}</span>
          </S.DataWrap>,
          <S.DataWrap key={`colName-${key}`}>
            <span>{item.Coluna}</span>
          </S.DataWrap>,
          <S.DataWrap key={`ErrorDescription-${key}`}>
            <span>{item.Mensagem}</span>
          </S.DataWrap>,
        ],
        id: `id-${key}`,
      }
    })
  }

  return (
    <Modal
      modalWidth={1000}
      open={data.length > 0}
      setOpen={handleSetOpen}
      title={'Resumo das inconsistências'}
    >
      <S.Container>
        <S.Summary>{renderSummary()}</S.Summary>
        <Table
          bodyData={renderBody()}
          distributeWidth={false}
          headData={headDataUpload}
          rowHeight={40}
        />
      </S.Container>
    </Modal>
  )
}

export default UploadAnalysisErrorModal
